import { Pipe, PipeTransform } from '@angular/core';
import { InstallationStatusPluginService } from './status.service';
@Pipe({
    name: 'statustype',
    standalone: false
})
export class StatusTypePipe implements PipeTransform {
  public surfaceTypes: any[];
  constructor(private service: InstallationStatusPluginService) {
    this.surfaceTypes = this.service.getStatusTypes();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.surfaceTypes);
  }
}
